/* eslint-disable */ 

 export const LIST_LIEU_LIVRAISON = {
    title: 'Liste des lieux de livraison',
    breadcrumb: {
      home: 'Accueil',
      liste: 'Liste des lieux de livraison',
    },
    actions: {
      add: 'Nouveau lieu de livraison',
      delete: 'Supprimer',
      search: 'Rechercher',
      filtre: 'Filtre',
    },
    err: {
      nom: 'Le champ Raison sociale est obligatoire',
    },
    tab: {
      code: 'Code',
      nom: 'Raison sociale',
      adresse: 'Adresse',
      ville: 'Ville',
      cp: 'CP',
      telephone: 'Téléphone',
      portable: 'Portable',
      email: 'Email',
      codeComptable: 'Code comptable',
      archive: 'Archivé',
      actions: {
        edit: 'Modifier',
        delete: 'Supprimer',
        archive: 'Archiver',
      },
    },
    filtre: {
      title: 'Filtre',
      sousTitle: 'Les filtres seront appliqués à la liste',
      lieuDeLivraison: 'Lieu de Livraison',
      archive: 'Archivé',
      ville: 'Ville(s)',
      email: 'Email',
      telephone: 'Téléphone',
      type: 'Type(s)',
      yes: 'Oui',
      no: 'Non',
      actions: {
        search: 'Rechercher',
        reinitialiser: 'Réinitialiser',
        appliquer: 'Appliquer',
      },
    },
    archivage: {
      titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce lieu de livraison ?',
      title: 'Etes-vous sûr de vouloir archiver ce lieu de livraison ?',
      yes: 'Oui',
      no: 'Non',
      sucessArchivage: 'Lieu de livraison archivé avec succès',
      sucessDesarchivage: 'Lieu de livraison désarchivé avec succès',
    },
  };
